import Vue from 'vue'
import { getMessage } from './utils'

const PRIMARY = 'primary'
const SUCCESS = 'success'
const ERROR = 'error'
const WARNING = 'warning'
const INFO = 'info'

const confirmDialogDefaults = {
    center: false
}

const $confirmDialog = function (data, type = 'primary', opts = confirmDialogDefaults) {
    return new Promise((resolve, reject) => {
        Vue.prototype.$confirm(getMessage(data), '提示', {
            showCancelButton: true,
            ...opts,
            center: false,
            customClass: `el-message-box__${type} ${opts.center ? 'el-message-box__center' : ''}`,
            iconClass: `el-icon-${type} ${opts.iconClass ? opts.iconClass : ''} el-message-box--icon`,
            type
          }).then(() => {
            resolve()
          }).catch(() => {
            reject()
          })
    })
    
}
  
$confirmDialog.success = function (data, opts = confirmDialogDefaults) {
    return $confirmDialog(data, SUCCESS, opts)
}
  
$confirmDialog.error = function (data, opts = confirmDialogDefaults) {
    return $confirmDialog(data, ERROR, opts)
}
  
$confirmDialog.warning = function (data, opts = confirmDialogDefaults) {
    return $confirmDialog(data, WARNING, opts)
}
  
$confirmDialog.info = function (data, opts = confirmDialogDefaults) {
    return $confirmDialog(data, INFO, opts)
}
  
function $alertDialog (data, type, opts = {}) {
    opts.showCancelButton = false
    return $confirmDialog(data, type, opts)
}

$alertDialog.success = function (data, opts = {}) {
    return $alertDialog(data, SUCCESS, opts)
}
  
$alertDialog.error = function (data, opts = {}) {
    return $alertDialog(data, ERROR, opts)
}
  
$alertDialog.warning = function (data, opts = {}) {
    return $alertDialog(data, WARNING, opts)
}
  
$alertDialog.info = function (data, opts = {}) {
    return $alertDialog(data, INFO, opts)
}
  
Vue.prototype.$confirmDialog = $confirmDialog
Vue.prototype.$c = $confirmDialog
Vue.prototype.$c.s = $confirmDialog.success
Vue.prototype.$c.w = $confirmDialog.warning
Vue.prototype.$c.e = $confirmDialog.error
Vue.prototype.$c.i = $confirmDialog.info
Vue.prototype.$alertDialog = $alertDialog

export default {
    methods: {
        $tips (data, type = 'success', opts = {}) {
            this.$Message[type]({
              ...opts,
              duration: 2,
              content: getMessage(data)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/feedback.js